@if (!!language()) {
    <code-editor [indentWithTab]="true"
                 [languages]="[language()]"
                 [language]="language().name"
                 [extensions]="extensions()"
                 [disabled]="disabled()"
                 [value]="value()"
                 [theme]="theme()">
    </code-editor>
}